const modal_confirm_change_tab = {
  title: 'Tienes cambios sin guardar',
  subtitle: 'Al confirmar, perderás todos los cambios sin guardar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
}

export default modal_confirm_change_tab
